export default __webpack_public_path__ + "static/media/logo.89e11640.png";